module.exports = __webpack_public_path__ + "static/media/28_tn.808b6d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/28_tn.jpg
// module id = 664
// module chunks = 0